/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Entercontent5Inputs */

const en_coinvestments_lpdealoverviewcontent_entercontent5 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Entercontent5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter content...`)
};

/**
* | output |
* | --- |
* | "Enter content..." |
*
* @param {Coinvestments_Lpdealoverviewcontent_Entercontent5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_entercontent5 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Entercontent5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Entercontent5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_entercontent5(inputs)
});
export { coinvestments_lpdealoverviewcontent_entercontent5 as "coInvestments_lpDealOverviewContent_enterContent" }